import {
    CLEAR_DDL_SQL,
    CLEAR_FIELD_DESCRIPTIONS,
    CLEAR_GAP_PREDICTION,
    CLEAR_PII_SUGGESTIONS,
    CREATE_SCHEMA_MODEL_FAILURE,
    CREATE_SCHEMA_MODEL_SUCCESS,
    DELETE_MAPPING_CONFIGURATION_FAILURE,
    DELETE_MAPPING_CONFIGURATION_SUCCESS,
    DELETE_SCHEMA_MODEL_FAILURE,
    DELETE_SCHEMA_MODEL_SUCCESS,
    GENERATE_DDL_SQL_FAILURE,
    GENERATE_DDL_SQL_REQUEST,
    GENERATE_DDL_SQL_SUCCESS,
    GENERATE_GAP_PREDICTION_FAILURE,
    GENERATE_GAP_PREDICTION_REQUEST,
    GENERATE_GAP_PREDICTION_SUCCESS,
    GENERATE_SCHEMA_HEALTH_REPORT_FAILURE,
    GENERATE_SCHEMA_HEALTH_REPORT_REQUEST,
    GENERATE_SCHEMA_HEALTH_REPORT_SUCCESS,
    GET_BUSINESS_AREA_DATA_FOR_BUSINESS_AREA_FAILURE,
    GET_BUSINESS_AREA_DATA_FOR_BUSINESS_AREA_REQUEST,
    GET_BUSINESS_AREA_DATA_FOR_BUSINESS_AREA_SUCCESS,
    GET_FIELD_DESCRIPTIONS_FAILURE,
    GET_FIELD_DESCRIPTIONS_REQUEST,
    GET_FIELD_DESCRIPTIONS_SUCCESS,
    GET_MAPPING_CONFIGURATIONS_FAILURE,
    GET_MAPPING_CONFIGURATIONS_SUCCESS,
    GET_PII_SUGGESTIONS_FAILURE,
    GET_PII_SUGGESTIONS_REQUEST,
    GET_PII_SUGGESTIONS_SUCCESS,
    GET_RECENT_SCHEMA_MODELS_FAILURE,
    GET_RECENT_SCHEMA_MODELS_SUCCESS,
    GET_SCHEMA_MODEL_BY_NAME_FAILURE,
    GET_SCHEMA_MODEL_BY_NAME_SUCCESS,
    GET_SCHEMA_MODEL_FAILURE,
    GET_SCHEMA_MODEL_SUCCESS,
    GET_SCHEMA_MODELS_FAILURE,
    GET_SCHEMA_MODELS_NEXT_PAGE_FAILURE,
    GET_SCHEMA_MODELS_NEXT_PAGE_SUCCESS,
    GET_SCHEMA_MODELS_SUCCESS,
    GET_USER_BUSINESS_AREA_BY_NAME_FAILURE,
    GET_USER_BUSINESS_AREA_BY_NAME_SUCCESS,
    GET_USER_SCHEMA_MODELS_PERMISSION_FAILURE,
    GET_USER_SCHEMA_MODELS_PERMISSION_SUCCESS,
    SAVE_FIELD_DESCRIPTIONS_FAILURE,
    SAVE_FIELD_DESCRIPTIONS_REQUEST,
    SAVE_FIELD_DESCRIPTIONS_SUCCESS,
    SAVE_MAPPING_CONFIGURATION_FAILURE,
    SAVE_MAPPING_CONFIGURATION_SUCCESS,
    SAVE_PII_SUGGESTIONS_FAILURE,
    SAVE_PII_SUGGESTIONS_REQUEST,
    SAVE_PII_SUGGESTIONS_SUCCESS,
    UPDATE_SCHEMA_MODEL_FAILURE,
    UPDATE_SCHEMA_MODEL_SUCCESS,
    UPLOAD_SCHEMA_MODEL_DEFINITION_FAILURE,
    UPLOAD_SCHEMA_MODEL_DEFINITION_SUCCESS,
} from "./actions";

import { GET_USER_BUSINESS_AREAS_SUCCESS } from "../home/actions";

import { DELETE_DATA_SET_SUCCESS } from "../actions";

const initialState = {
    getUserBusinessAreaByNameResult: {
        success: true,
    },
    createSchemaModelResult: {
        success: true,
    },
    getSchemaModelsResult: {
        success: true,
    },
    getSchemaModelsNextPageResult: {
        success: true,
    },
    getRecentSchemaModelsResult: {
        success: true,
    },
    deleteSchemaModelResult: {
        success: true,
    },
    getSchemaModelResult: {
        success: true,
    },
    updateSchemaModelResult: {
        success: true,
    },
    userBusinessAreas: {},
    getUserSchemaModelsPermissionResult: {
        success: true,
    },
    getBusinessAreaDataForBusinessAreaResult: {
        success: true,
        inProgress: false,
    },
    schemaModelListResult: {
        Items: [],
    },
    recentSchemaModelListResult: {
        Items: [],
    },
    uploadSchemaModelDefinitionResult: {
        success: true,
    },
    schemaModel: null,
    createdSchemaModel: null,
    permission: null,
    businessAreaDataList: [],
    schemaModelDefinitionFile: null,
    saveMappingConfigurationResult: {
        success: true,
    },
    getMappingConfigurationsResult: {
        success: true,
    },
    deleteMappingConfigurationResult: {
        success: true,
    },
    mappingConfigurations: {
        Items: [],
    },
    generateSchemaHealthReportResult: {
        success: true,
        loading: false,
    },
    schemaHealthReportHtml: null,
    getPiiSuggestionsResult: {
        success: true,
        loading: false,
    },
    piiSuggestionsData: null,
    savePiiSuggestionsResult: {
        success: true,
        loading: false,
    },
    getFieldDescriptionsResult: {
        success: true,
        loading: false,
    },
    fieldDescriptionsData: null,
    saveFieldDescriptionsResult: {
        success: true,
        loading: false,
    },
    generateDdlSqlResult: {
        success: true,
        loading: false,
    },
    ddlSqlData: null,
    generateGapPredictionResult: {
        success: true,
        loading: false,
    },
    gapPredictionData: null,
};

export default (state = initialState, action) => {
    let schemaModelListResult = {
        Items: [],
    };
    switch (action.type) {
        case GET_USER_BUSINESS_AREA_BY_NAME_SUCCESS:
            return {
                ...state,
                getUserBusinessAreaByNameResult: { success: true, requestedName: action.requestedName },
                userBusinessAreas: { [action.payload.name.toLowerCase()]: action.payload },
            };
        case GET_USER_BUSINESS_AREA_BY_NAME_FAILURE:
            return { ...state, getUserBusinessAreaByNameResult: { success: false, ...action.payload }, userBusinessAreas: { [action.payload.businessAreaName]: null } };
        case CREATE_SCHEMA_MODEL_SUCCESS:
            schemaModelListResult = { ...state.schemaModelListResult };
            schemaModelListResult.Items = [...schemaModelListResult.Items];
            schemaModelListResult.Items.splice(0, 0, action.payload.schemaModel);
            return { ...state, createSchemaModelResult: { success: true }, createdSchemaModel: action.payload.schemaModel, schemaModelListResult };
        case CREATE_SCHEMA_MODEL_FAILURE:
            return { ...state, createSchemaModelResult: { success: false, ...action.payload }, createdSchemaModel: null };
        case GET_SCHEMA_MODELS_SUCCESS:
            return { ...state, getSchemaModelsResult: { success: true }, schemaModelListResult: action.payload };
        case GET_SCHEMA_MODELS_FAILURE:
            return {
                ...state,
                getSchemaModelsResult: { success: false, ...action.payload },
                schemaModelListResult: {
                    Items: [],
                },
            };
        case GET_SCHEMA_MODELS_NEXT_PAGE_SUCCESS:
            return {
                ...state,
                getSchemaModelsNextPageResult: {
                    success: true,
                },
                schemaModelListResult: {
                    ...action.payload,
                    Items: state.schemaModelListResult.Items.concat(action.payload.Items),
                },
            };
        case GET_SCHEMA_MODELS_NEXT_PAGE_FAILURE:
            return {
                ...state,
                getSchemaModelsNextPageResult: {
                    success: false,
                    ...action.payload,
                },
            };
        case GET_RECENT_SCHEMA_MODELS_SUCCESS:
            return { ...state, getRecentSchemaModelsResult: { success: true }, recentSchemaModelListResult: action.payload };
        case GET_RECENT_SCHEMA_MODELS_FAILURE:
            return {
                ...state,
                getRecentSchemaModelsResult: { success: false, ...action.payload.error },
                recentSchemaModelListResult: {
                    Items: [],
                },
            };
        case GET_USER_BUSINESS_AREAS_SUCCESS:
            let businessAreasDict = action.payload.businessAreasDict;
            let recentSchemaModelListResult = state.recentSchemaModelListResult;
            if (recentSchemaModelListResult.Items.length > 0) {
                recentSchemaModelListResult = { ...state.recentSchemaModelListResult };
                recentSchemaModelListResult.Items = [...recentSchemaModelListResult.Items];
                for (let i = 0; i < recentSchemaModelListResult.Items.length; i++) {
                    let recentSchemaModel = recentSchemaModelListResult.Items[i];
                    if (businessAreasDict && businessAreasDict[recentSchemaModel.businessAreaId]) {
                        recentSchemaModelListResult.Items[i] = { ...recentSchemaModel, businessAreaName: businessAreasDict[recentSchemaModel.businessAreaId].name };
                    }
                }
            }
            return { ...state, recentSchemaModelListResult };
        case DELETE_SCHEMA_MODEL_SUCCESS:
            schemaModelListResult = { ...state.schemaModelListResult };
            schemaModelListResult.Items = [...schemaModelListResult.Items];
            let deletedSchemaModelIndex = schemaModelListResult.Items.findIndex((item) => item.schemaId === action.payload.schemaId);
            if (deletedSchemaModelIndex > -1) {
                schemaModelListResult.Items.splice(deletedSchemaModelIndex, 1);
            }
            return { ...state, deleteSchemaModelResult: { success: true }, schemaModelListResult };
        case DELETE_SCHEMA_MODEL_FAILURE:
            return { ...state, deleteSchemaModelResult: { success: false, ...action.payload } };
        case GET_SCHEMA_MODEL_SUCCESS:
            return {
                ...state,
                getSchemaModelResult: { success: true },
                schemaModel: action.payload,
                mappingConfigurations: action.payload?.mappingConfigurations
                    ? { Items: Array.isArray(action.payload.mappingConfigurations) ? action.payload.mappingConfigurations : [] }
                    : state.mappingConfigurations,
            };
        case GET_SCHEMA_MODEL_FAILURE:
            return { ...state, getSchemaModelResult: { success: false, ...action.payload }, schemaModel: null };
        case GET_SCHEMA_MODEL_BY_NAME_SUCCESS:
            return {
                ...state,
                getSchemaModelResult: { success: true },
                schemaModel: action.payload.schemaModel,
                mappingConfigurations: action.payload.schemaModel?.mappingConfigurations
                    ? { Items: Array.isArray(action.payload.schemaModel.mappingConfigurations) ? action.payload.schemaModel.mappingConfigurations : [] }
                    : state.mappingConfigurations,
            };
        case GET_SCHEMA_MODEL_BY_NAME_FAILURE:
            return { ...state, getSchemaModelResult: { success: false, ...action.payload }, schemaModel: null };
        case UPDATE_SCHEMA_MODEL_SUCCESS:
            return { ...state, updateSchemaModelResult: { success: true, source: action.payload && action.payload.source } };
        case UPDATE_SCHEMA_MODEL_FAILURE:
            return { ...state, updateSchemaModelResult: { success: false, ...action.payload } };
        case GET_USER_SCHEMA_MODELS_PERMISSION_SUCCESS:
            return { ...state, getUserSchemaModelsPermissionResult: { success: true }, permission: action.payload };
        case GET_USER_SCHEMA_MODELS_PERMISSION_FAILURE:
            return { ...state, getUserSchemaModelsPermissionResult: { success: false, ...action.payload }, permission: null };
        case GET_BUSINESS_AREA_DATA_FOR_BUSINESS_AREA_REQUEST:
            return { ...state, getBusinessAreaDataForBusinessAreaResult: { ...state.getBusinessAreaDataForBusinessAreaResult, inProgress: true }, businessAreaDataList: [] };
        case GET_BUSINESS_AREA_DATA_FOR_BUSINESS_AREA_SUCCESS:
            return { ...state, getBusinessAreaDataForBusinessAreaResult: { success: true, inProgress: false }, businessAreaDataList: action.payload };
        case GET_BUSINESS_AREA_DATA_FOR_BUSINESS_AREA_FAILURE:
            return { ...state, getBusinessAreaDataForBusinessAreaResult: { success: false, inProgress: false, ...action.payload }, businessAreaDataList: [] };
        case DELETE_DATA_SET_SUCCESS:
            schemaModelListResult = { ...state.schemaModelListResult };
            schemaModelListResult.Items = [...schemaModelListResult.Items];
            let deletedDataSetSchemaIndex = schemaModelListResult.Items.findIndex((item) => item.schemaId === action.payload.schemaId);
            if (deletedDataSetSchemaIndex > -1) {
                let dataSetCount = 0;
                if (schemaModelListResult.Items[deletedDataSetSchemaIndex].dataSetCount) {
                    dataSetCount = schemaModelListResult.Items[deletedDataSetSchemaIndex].dataSetCount - 1;
                }
                schemaModelListResult.Items[deletedDataSetSchemaIndex] = { ...schemaModelListResult.Items[deletedDataSetSchemaIndex], dataSetCount: dataSetCount };
            }
            return { ...state, schemaModelListResult };
        case UPLOAD_SCHEMA_MODEL_DEFINITION_SUCCESS:
            return { ...state, uploadSchemaModelDefinitionResult: { success: true }, schemaModelDefinitionFile: action.payload };
        case UPLOAD_SCHEMA_MODEL_DEFINITION_FAILURE:
            return { ...state, uploadSchemaModelDefinitionResult: { success: false, ...action.payload.error }, schemaModelDefinitionFile: null };
        case SAVE_MAPPING_CONFIGURATION_SUCCESS:
            return { ...state, saveMappingConfigurationResult: { success: true }, mappingConfigurations: action.payload };
        case SAVE_MAPPING_CONFIGURATION_FAILURE:
            return { ...state, saveMappingConfigurationResult: { success: false, ...action.payload } };
        case GET_MAPPING_CONFIGURATIONS_SUCCESS:
            return { ...state, getMappingConfigurationsResult: { success: true }, mappingConfigurations: action.payload };
        case GET_MAPPING_CONFIGURATIONS_FAILURE:
            return { ...state, getMappingConfigurationsResult: { success: false, ...action.payload }, mappingConfigurations: { Items: [] } };
        case DELETE_MAPPING_CONFIGURATION_SUCCESS:
            return { ...state, deleteMappingConfigurationResult: { success: true }, mappingConfigurations: action.payload };
        case DELETE_MAPPING_CONFIGURATION_FAILURE:
            return { ...state, deleteMappingConfigurationResult: { success: false, ...action.payload } };
        case GENERATE_SCHEMA_HEALTH_REPORT_REQUEST:
            return { ...state, generateSchemaHealthReportResult: { success: true, loading: true }, schemaHealthReportHtml: null };
        case GENERATE_SCHEMA_HEALTH_REPORT_SUCCESS:
            return { ...state, generateSchemaHealthReportResult: { success: true, loading: false }, schemaHealthReportHtml: action.payload.reportHtml };
        case GENERATE_SCHEMA_HEALTH_REPORT_FAILURE:
            return { ...state, generateSchemaHealthReportResult: { success: false, loading: false, ...action.payload.error }, schemaHealthReportHtml: null };
        case GET_PII_SUGGESTIONS_REQUEST:
            return { ...state, getPiiSuggestionsResult: { success: true, loading: true }, piiSuggestionsData: null };
        case GET_PII_SUGGESTIONS_SUCCESS:
            return { ...state, getPiiSuggestionsResult: { success: true, loading: false }, piiSuggestionsData: action.payload };
        case GET_PII_SUGGESTIONS_FAILURE:
            return { ...state, getPiiSuggestionsResult: { success: false, loading: false, ...action.payload }, piiSuggestionsData: null };
        case SAVE_PII_SUGGESTIONS_REQUEST:
            return { ...state, savePiiSuggestionsResult: { success: true, loading: true } };
        case SAVE_PII_SUGGESTIONS_SUCCESS:
            return { ...state, savePiiSuggestionsResult: { success: true, loading: false }, piiSuggestionsData: null };
        case SAVE_PII_SUGGESTIONS_FAILURE:
            return { ...state, savePiiSuggestionsResult: { success: false, loading: false, ...action.payload } };
        case CLEAR_PII_SUGGESTIONS:
            return { ...state, getPiiSuggestionsResult: { success: true, loading: false }, piiSuggestionsData: null, savePiiSuggestionsResult: { success: true, loading: false } };
        case GET_FIELD_DESCRIPTIONS_REQUEST:
            return { ...state, getFieldDescriptionsResult: { success: true, loading: true }, fieldDescriptionsData: null };
        case GET_FIELD_DESCRIPTIONS_SUCCESS:
            return { ...state, getFieldDescriptionsResult: { success: true, loading: false }, fieldDescriptionsData: action.payload };
        case GET_FIELD_DESCRIPTIONS_FAILURE:
            return { ...state, getFieldDescriptionsResult: { success: false, loading: false, ...action.payload }, fieldDescriptionsData: null };
        case SAVE_FIELD_DESCRIPTIONS_REQUEST:
            return { ...state, saveFieldDescriptionsResult: { success: true, loading: true } };
        case SAVE_FIELD_DESCRIPTIONS_SUCCESS:
            return { ...state, saveFieldDescriptionsResult: { success: true, loading: false }, fieldDescriptionsData: null };
        case SAVE_FIELD_DESCRIPTIONS_FAILURE:
            return { ...state, saveFieldDescriptionsResult: { success: false, loading: false, ...action.payload } };
        case CLEAR_FIELD_DESCRIPTIONS:
            return {
                ...state,
                getFieldDescriptionsResult: { success: true, loading: false },
                fieldDescriptionsData: null,
                saveFieldDescriptionsResult: { success: true, loading: false },
            };
        case GENERATE_DDL_SQL_REQUEST:
            return { ...state, generateDdlSqlResult: { success: true, loading: true }, ddlSqlData: null };
        case GENERATE_DDL_SQL_SUCCESS:
            return { ...state, generateDdlSqlResult: { success: true, loading: false }, ddlSqlData: action.payload };
        case GENERATE_DDL_SQL_FAILURE:
            return { ...state, generateDdlSqlResult: { success: false, loading: false, ...action.payload }, ddlSqlData: null };
        case CLEAR_DDL_SQL:
            return { ...state, generateDdlSqlResult: { success: true, loading: false }, ddlSqlData: null };
        case GENERATE_GAP_PREDICTION_REQUEST:
            return { ...state, generateGapPredictionResult: { success: true, loading: true }, gapPredictionData: null };
        case GENERATE_GAP_PREDICTION_SUCCESS:
            return { ...state, generateGapPredictionResult: { success: true, loading: false }, gapPredictionData: action.payload };
        case GENERATE_GAP_PREDICTION_FAILURE:
            return { ...state, generateGapPredictionResult: { success: false, loading: false, ...action.payload }, gapPredictionData: null };
        case CLEAR_GAP_PREDICTION:
            return { ...state, generateGapPredictionResult: { success: true, loading: false }, gapPredictionData: null };
        default:
            return state;
    }
};
